import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=ded5d20c&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=ts"
export * from "./Pricing.vue?vue&type=script&lang=ts"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=ded5d20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5d20c",
  null
  
)

export default component.exports